import { Component, Host, h, Prop } from '@stencil/core';
import { AlignContent, AlignItems, FlexDirection, JustifyContent, Wrap } from './types';

export interface AhaFlex extends HTMLAhaFlexElement {}

/**
 * @deprecated
 * This component is Deprecated. Use css instead.
 */
@Component({
  tag: 'aha-flex',
  styleUrl: 'aha-flex.css',
  shadow: true,
})
export class AhaFlex {
  componentWillLoad() {
    console.warn('<aha-flex> is deprecated, use css instead.');
  }
  /**
   * The direction in which to layout children.
   *
   * See [MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction).
   */
  @Prop() direction: FlexDirection = 'row';

  /**
   * How items are aligned along the flex container's cross axis.
   *
   * See [MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/align-items).
   */
  @Prop() alignItems: AlignItems = 'stretch';

  /**
   * The distribution of space around items along the main axis.
   *
   * See [MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content).
   */
  @Prop() justifyContent: JustifyContent = 'stretch';

  /**
   * The distribution of space around child items along the cross axis.
   *
   * See [MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/align-content).
   */
  @Prop() alignContent: AlignContent = 'flex-start';

  /**
   * Whether to wrap items onto multiple lines.
   *
   * See [MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-wrap).
   */
  @Prop() wrap: Wrap = 'nowrap';

  /**
   * The space to display between both rows and columns.
   *
   * See [MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/gap).
   */
  @Prop() gap: string = '0';

  render() {
    return (
      <Host
        style={{
          display: 'flex',
          gap: this.gap,
          flexDirection: this.direction,
          alignContent: this.alignContent,
          alignItems: this.alignItems,
          justifyContent: this.justifyContent,
          flexWrap: this.wrap,
        }}
      >
        <slot></slot>
      </Host>
    );
  }
}
